import { Tag, Dropdown, Menu, Radio, Button as AntdButton } from 'antd';
import type { ReactNode } from 'react';

import { ChevronSVG } from 'components/iconsSVG/chevron';
import { CloseSVG } from 'components/iconsSVG/close';
import { useI18n } from 'context/i18n';
import { filterColors, sorts, type TSort } from 'utils/filters';
import { FilterSVG } from 'components/iconsSVG/filter';
import { FilterTag } from 'components/filterTag';
import type { FilterState } from './use-filters';

import styles from '../filter/style.module.css';

type CamperFilterHeaderProps = {
  state: FilterState;
  toggle: () => void;
  count: number;
  total: number;
  onRemoveFilter: (params: { parent: string; key: string }) => void;
  onReset: () => void;
  onSort: (sort: TSort) => void;
};

export function CamperFilterHeader({ state, toggle, count, total, onRemoveFilter, onReset, onSort }: CamperFilterHeaderProps) {
  const { t } = useI18n();

  return (
    <div className={styles.filtersRow}>
      <div className={styles.filtersDivider} data-menu-open={state.open}></div>
      <div className={styles.panelLeft} data-menu-open={state.open}>
        <AntdButton className={`${styles.filterText} ${styles.filterHeaderBtn}`} size="small" type="text" onClick={toggle}>
          {state.open ?
            <div>
              <CloseSVG /> <span>{t('menu.lateral', 'cerrarfiltros', 'Close filters')}</span>
            </div>
          : <div>
              <FilterSVG />{' '}
              <span>
                {t('menu.lateral', 'filtrar', 'Filter')} {count > 0 ? ` (${count})` : ''}
              </span>
            </div>
          }
        </AntdButton>
      </div>
      <div className={styles.panelRight}>
        <div className={`${styles.appliedFilters}`}>
          {Object.entries(state.active).reduce((acc, [parent, filters], i, arr) => {
            for (const [key, filter] of filters) {
              acc.push(
                <FilterTag
                  key={`${parent}.${key}`}
                  onClick={() => onRemoveFilter({ parent, key })}
                  color={filter.key.includes('color') ? filterColors[filter.key] : null}
                  label={filter.label !== '' ? filter.label : filter.urlParam}
                  checked={true}
                />,
              );
            }
            if (i === arr.length - 1 && arr.length > 0) {
              acc.push(
                <Tag key="reset-button" className={styles.resetTag} onClick={onReset}>
                  {t('generico', 'boton.reiniciar', 'Reset')}
                  <span className={styles.closeMarkSpan}>
                    <CloseSVG />
                  </span>
                </Tag>,
              );
            }
            return acc;
          }, [] as ReactNode[])}
        </div>
        <div className={styles.sortsDiv}>
          <p className={styles.productList}>
            {total} {t('listado.productos', 'articulos').toUpperCase()}
          </p>
          <div className={styles.dropdownWrapper}>
            <div className={styles.filterText}>{t('menu.lateral', 'ordenar.por')} :</div>
            {/* @ts-ignore !antd!! */}
            <Dropdown
              overlay={
                <Menu>
                  {Object.keys(sorts).map((sortValue) => (
                    <Menu.Item key={sortValue}>
                      <Radio onClick={() => onSort(sortValue as TSort)} className={styles.sortRadio} checked={state.sort === sortValue}>
                        {t('listado.productos', sorts[sortValue])}
                      </Radio>
                    </Menu.Item>
                  ))}
                </Menu>
              }
              overlayClassName={styles.sortsDropdown}
              placement="bottomCenter"
              trigger={['click']}
            >
              <AntdButton size="small" type="text" className={`${styles.filterText} ${styles.filterHeaderBtn}`}>
                {t('listado.productos', sorts[state.sort])} <ChevronSVG className={styles.dropdownChevron} />
              </AntdButton>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
}
